(function () {
  'use strict';

  const nav = document.querySelector('.cascade-nav');
  if (!nav) return;

  const hamburger = nav.querySelector('.cascade-nav__hamburger');
  const panel     = nav.querySelector('.cascade-nav__l1');
  const closeBtn  = nav.querySelector('.cascade-nav__close');
  const overlay   = nav.querySelector('.cascade-nav__overlay');

  // ── Mobile panel open/close ────────────────────────────
  function openPanel() {
    panel.classList.add('is-open');
    overlay.classList.add('is-visible');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    panel.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', () => {
    panel.classList.contains('is-open') ? closePanel() : openPanel();
  });

  closeBtn.addEventListener('click', closePanel);
  overlay.addEventListener('click', closePanel);

  // ── Helpers ────────────────────────────────────────────
  function open(item) {
    const dropdown = item.querySelector(':scope > .cascade-nav__dropdown');
    const link     = item.querySelector(':scope > .cascade-nav__link');
    if (!dropdown) return;
    item.classList.add('is-open');
    dropdown.classList.add('is-open');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  function close(item) {
    const dropdown = item.querySelector(':scope > .cascade-nav__dropdown');
    const link     = item.querySelector(':scope > .cascade-nav__link');
    if (!dropdown) return;
    item.classList.remove('is-open');
    dropdown.classList.remove('is-open');
    if (link) link.setAttribute('aria-expanded', 'false');
    item.querySelectorAll('.is-open').forEach(el => el.classList.remove('is-open'));
  }

  function closeAll(except) {
    nav.querySelectorAll('.cascade-nav__item.is-open').forEach(item => {
      if (item !== except && !item.contains(except)) close(item);
    });
  }

  function isMobile() {
    return window.innerWidth <= 989;
  }

  function hoverOpen(item, parentDropdown) {
    clearTimeout(item._closeTimer);
    closeAll(item);
    open(item);
    if (parentDropdown) clearTimeout(parentDropdown._closeTimer);
  }

  function hoverClose(item, delayMs = 150) {
    item._closeTimer = setTimeout(() => close(item), delayMs);
  }

  // ── L1: hover on desktop, tap on mobile ───────────────
  nav.querySelectorAll('.cascade-nav__item--l1.has-children').forEach(item => {
    const l2 = item.querySelector('.cascade-nav__dropdown--l2');

    // Desktop: hover open/close
    item.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      hoverOpen(item, null);
    });

    item.addEventListener('mouseleave', () => {
      if (isMobile()) return;
      hoverClose(item, 150);
    });

    l2?.addEventListener('mouseenter', () => clearTimeout(item._closeTimer));
    l2?.addEventListener('mouseleave', () => hoverClose(item, 150));

    // Single click handler: blocks # on desktop, toggles dropdown on mobile
    item.querySelector('.cascade-nav__link--l1')
      ?.addEventListener('click', (e) => {
        if (!isMobile()) {
          if (e.currentTarget.getAttribute('href') === '#') e.preventDefault();
          return;
        }
        e.preventDefault();
        const isOpen = item.classList.contains('is-open');
        closeAll(item);
        isOpen ? close(item) : open(item);
      });
  });

  // ── L2: hover on desktop, tap on mobile ───────────────
  nav.querySelectorAll('.cascade-nav__item--l2.has-children').forEach(item => {
    const l3 = item.querySelector('.cascade-nav__dropdown--l3');
    const parentL2 = item.closest('.cascade-nav__dropdown--l2');

    item.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      clearTimeout(item._closeTimer);
      parentL2?.querySelectorAll('.cascade-nav__item--l2.is-open').forEach(sib => {
        if (sib !== item) close(sib);
      });
      open(item);
    });

    item.addEventListener('mouseleave', () => {
      if (isMobile()) return;
      hoverClose(item, 150);
    });

    l3?.addEventListener('mouseenter', () => clearTimeout(item._closeTimer));
    l3?.addEventListener('mouseleave', () => hoverClose(item, 150));

    item.querySelector('.cascade-nav__link--l2')
      ?.addEventListener('click', (e) => {
        if (!isMobile()) return;
        e.preventDefault();
        const isOpen = item.classList.contains('is-open');
        parentL2?.querySelectorAll('.cascade-nav__item--l2.is-open')
          .forEach(sib => { if (sib !== item) close(sib); });
        isOpen ? close(item) : open(item);
      });
  });

  // ── Close on outside click ─────────────────────────────
  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) closeAll(null);
  });

  // ── Close on Escape ────────────────────────────────────
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll(null);
      closePanel();
    }
  });

})();